import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/bram/Development/cal.mijnafspraken.online/webflux_deploy/production/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/Users/bram/Development/cal.mijnafspraken.online/webflux_deploy/production/node_modules/next/dist/client/script.js");
